import React from "react";
import NumberedHeading from "../components/NumberedHeading";
import SectionBgImg from "../components/SectionBgImg";
import ResultChart from "../../../Components/DetailResultPage/ResultChart";
import { useRecoilValueLoadable } from "recoil";
import { resultSelector } from "../../../utils/recoil";
import { useTranslation } from "react-i18next";

const getResultItem = (result) => (Array.isArray(result) ? result[0] : result);

const Graph = ({ resultOverride }) => {
  const resultLoadable = useRecoilValueLoadable(resultSelector);
  const result =
    resultOverride ??
    (resultLoadable.state === "hasValue" ? resultLoadable.contents : undefined);
  const resultItem = getResultItem(result);
  const { t } = useTranslation("result");
  const canShowChart = resultItem?.prediction?.holland?.values;

  return (
    <div className="py-20 md-max:py-10">
      <NumberedHeading
        number={"1"}
        title={t("careerPath.title")}
        className={"px-[20rem] md-max:px-[1rem]"}
      />
      <div className="my-10 px-[20rem] md-max:px-[1rem] relative">
        <SectionBgImg className={"top-1/2 -translate-y-1/2"} />
        <div className="flex flex-col gap-10 justify-center items-center">
          {canShowChart && <ResultChart item={resultItem} />}
          <p>
            <span className="text-[#3976f9] font-bold">
              {t("careerPath.description").split(", ")[0]},
            </span>{" "}
            {t("careerPath.description").split(", ")[1]}{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Graph;
